/**
 * Props que todo campo do formulário de equipamento de incêndio repete: o texto de apoio em
 * 16px (o padrão do MUI é 12px, pequeno demais para quem lê de longe) e o rótulo sempre acima
 * do campo, que é como o desenho mostra os selects nativos e as datas.
 */
import type { FormHelperTextProps, InputLabelProps } from '@mui/material';

export const HELPER_TEXT_PROPS: Partial<FormHelperTextProps> = { sx: { fontSize: '1rem' } };

export const LABEL_ABOVE: Partial<InputLabelProps> = { shrink: true };
